"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentUser = void 0;
var react_1 = __importDefault(require("react"));
require("./CurrentUser.scss");
var CurrentUser = function (props) { return (react_1.default.createElement("div", { className: "current-user" },
    react_1.default.createElement("div", { className: "user-avatar-container" },
        react_1.default.createElement("div", { className: "user-avatar" },
            react_1.default.createElement("span", { className: "icon" },
                react_1.default.createElement("i", { className: "fas fa-user-astronaut" })))),
    react_1.default.createElement("div", null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: "user-name" },
                props.user.firstName,
                " ",
                props.user.lastName)),
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: "user-title" }, props.user.profile.title))))); };
exports.CurrentUser = CurrentUser;
